import { render, staticRenderFns } from "./RefinedContent.vue?vue&type=template&id=720e5168&scoped=true"
import script from "./RefinedContent.vue?vue&type=script&lang=js"
export * from "./RefinedContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720e5168",
  null
  
)

export default component.exports